import React from "react";
import { Skeleton } from "@common/skeleton";
import { Project } from "./project";
import styles from "./styles.scss";

function Loader() {
  return (
    <div className={styles.zones}>
      <ul className={styles.list}>
        <li className={styles.item}>
          <Project />
        </li>
        <li className={styles.item}>
          <Project />
        </li>
        <li className={styles.item}>
          <Project />
        </li>
      </ul>
      <ul className={styles.list}>
        <li className={styles.item}>
          <Project />
        </li>
        <li className={styles.item}>
          <Project />
        </li>
        <li className={styles.item}>
          <Project />
        </li>
      </ul>
      <ul className={styles.list}>
        <li className={styles.item}>
          <Project />
        </li>
        <li className={styles.item}>
          <Project />
        </li>
        <li className={styles.item}>
          <Project />
        </li>
      </ul>
    </div>
  );
}

export { Loader };
